const isArray = require('lodash/isArray')
const isObject = require('lodash/isObject')
const isUndefined = require('lodash/isUndefined')
const isEmpty = require('lodash/isEmpty')

export const omitDeepBy = predicate => obj => {
  return Object.entries(obj).reduce((accumulator, [key, value]) => {
    if (predicate(value)) {
      return accumulator
    }
    return {
      ...accumulator,
      [key]:
        isObject(value) && !isArray(value)
          ? omitDeepBy(predicate)(value)
          : value,
    }
  }, {})
}

export const omitDeepByEmpty = omitDeepBy(isEmpty)
export const omitDeepByUndefined = omitDeepBy(isUndefined)
